import React, { Component } from "react";
import Constants from "Helpers/Constants";
import axios from "axios";
import DataTable from "examples/Tables/DataTable";
import card from "assets/theme/components/card";
import cardContent from "assets/theme/components/card/cardContent";
import init from "Helpers/WindowToken";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import { Link, Navigate, redirect } from "react-router-dom";
import {
  Autocomplete,
  Card,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
  TextareaAutosize,
  TableRow,
  TableCell,
} from "@mui/material";
// import Textarea from "@mui/joy/Textarea";
import MDBox from "components/MDBox";
import MDSnackbar from "components/MDSnackbar";
import MDTypography from "components/MDTypography";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDButton from "components/MDButton";
import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";

const fd = new FormData();
export default class AllotQuestions extends Component {
  state = {
    message: "",
    notification: false,
    blogs_poster: {},
    blogs_title: "",
    blog_content: "",
    blogs_for: "",

    suggested_questions: [],
    selected_questions: [],
    testseries_id: "",
    testserires_details: {},
  };

  componentDidMount() {
    const id = window.location.pathname.split("/")[2];

    this.setState({ testseries_id: id }, () => {
      this.getTestSeriesSuggestedQuestions(id); // Pass ID directly
    });
  }

  getTestSeriesSuggestedQuestions = (id) => {
    if (init() !== "success") {
      window.location.assign("/signin");
      return;
    }

    axios.get(`${Constants.getUrls.suggestedQuestions}?testseries_id=${id}`).then((resp) => {
      // console.log(resp.data.suggested_questions);

      if (resp.data.status === "success") {
        this.setState({
          testserires_details: resp.data.testseries || {},
          suggested_questions: resp.data.suggested_questions || [],
          selected_questions:
            resp.data.allotedQuestions.length > 0 ? resp.data.allotedQuestions[0].questions : [],
        });
      }
    });
  };

  handleInput = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  handleDescription = (e) => {
    // console.log(e);
    this.setState({ blog_content: e });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    let payload = {
      testSeriesId: this.state.testseries_id,
      questionsArray: this.state.selected_questions,
    };
    // return;
    if (init() === "success") {
      axios
        .post(Constants.postUrls.allotquestions, payload)
        .then((resp) => {
          // console.log(resp);
          this.setState({
            notification: true,
            message: resp.data.message,
          });
          setTimeout(() => {
            this.setState({ notification: false, message: "", redirect: true });
          }, 3000);
        })
        .catch((err) => {
          this.setState({
            notification: true,
            message: err.response.data.message,
          });
          setTimeout(() => {
            this.setState({ notification: false, message: "" });
          }, 5000);
        });
    }
  };

  render() {
    if (this.state.redirect === true) {
      return <Navigate to="/testseries" />;
    } else {
      return (
        <div>
          <div>
            <DashboardLayout>
              <DashboardNavbar />
              <MDBox pt={6} pb={3}>
                <Card>
                  <MDBox
                    mx={2}
                    mt={-3}
                    py={3}
                    px={2}
                    variant="gradient"
                    bgColor="info"
                    borderRadius="lg"
                    coloredShadow="info"
                  >
                    <MDTypography variant="h6" color="white">
                      Allot Questions
                    </MDTypography>
                  </MDBox>
                  {/* <Grid item sm={4} px={2} align="right">
                    <Link to="/admin/addNewJob">
                      <MDButton variant="contained" size="small" color="primary">
                        Create Job
                      </MDButton>
                    </Link>
                  </Grid> */}
                  <MDBox py={3} px={2}>
                    <form onSubmit={this.handleSubmit}>
                      <Grid container sm={12} spacing={2}>
                        <Grid item sm={6}>
                          {/*   */}
                        </Grid>
                      </Grid>
                      <TableRow>
                        <TableCell style={{ width: "5%", fontWeight: "bold" }}>S.no.</TableCell>
                        <TableCell style={{ width: "5%", fontWeight: "bold" }}> Select </TableCell>
                        <TableCell style={{ width: "90%", fontWeight: "bold" }}>Question</TableCell>
                      </TableRow>
                      {this.state.suggested_questions.length > 0 &&
                        this.state.suggested_questions.map((item, index) => (
                          <TableRow key={index}>
                            <TableCell style={{ width: "5%" }}>{index + 1}</TableCell>
                            <TableCell style={{ width: "5%" }}>
                              <input
                                type="checkbox"
                                checked={this.state.selected_questions.includes(item._id)}
                                onClick={() => {
                                  this.setState((prevState) => {
                                    const { selected_questions } = prevState;
                                    const findIndex = selected_questions.indexOf(item._id);
                                    if (findIndex !== -1) {
                                      // If the item is found, remove it
                                      return {
                                        selected_questions: selected_questions.filter(
                                          (id) => id !== item._id
                                        ),
                                      };
                                    } else {
                                      // If the item is not found, add it
                                      return {
                                        selected_questions: [...selected_questions, item._id],
                                      };
                                    }
                                  });
                                }}
                              />
                            </TableCell>
                            <TableCell style={{ width: "90%" }}>{item?.question}</TableCell>
                          </TableRow>
                        ))}

                      <Grid align="left" mt={2}>
                        <MDButton variant="contained" size="small" color="info" type="submit">
                          {this.state.loading ? "Creating..." : "Create"}
                        </MDButton>
                      </Grid>
                    </form>
                  </MDBox>
                  <>
                    <MDSnackbar
                      color="success"
                      icon="notifications"
                      title="Pro-Rider Career"
                      content={this.state.message}
                      dateTime="Just now"
                      open={this.state.notification}
                      //   close={toggleSnackbar}
                    />
                  </>
                </Card>
              </MDBox>
            </DashboardLayout>
          </div>
        </div>
      );
    }
  }
}
